import { Role } from "../../../model";
import { TaskAcceptInvitation } from "./task-types/TaskAcceptInvitation";
import { TaskAssignment } from "./task-types/TaskAssignment";
import { TaskBeginPhase } from "./task-types/TaskBeginPhase";
import { TaskCalendlyEvent } from "./task-types/TaskCalendlyEvent";
import { TaskCalendlyScheduledEvent } from "./task-types/TaskCalendlyScheduledEvent";
import { TaskCheck } from "./task-types/TaskCheck";
import { TaskCompleteProcessDependency } from "./task-types/TaskCompleteProcessDependency";
import { TaskContent } from "./task-types/TaskContent";
import { TaskCreateAccount } from "./task-types/TaskCreateAccount";
import { TaskDocuSignEvent } from "./task-types/TaskDocuSignEvent";
import { TaskEmail } from "./task-types/TaskEmail";
import { TaskForm } from "./task-types/TaskForm";
import { TaskInvitation } from "./task-types/TaskInvitation";
import { TaskOAuthLink } from "./task-types/TaskOAuthLink";
import { TaskProcessMonitor } from "./task-types/TaskProcessMonitor";
import { TaskProcessStart } from "./task-types/TaskProcessStart";
import { TaskRunwayApiCall } from "./task-types/TaskRunwayApiCall";
import { TaskShortCircuit } from "./task-types/TaskShortCircuit";
import { TaskSquareFetch } from "./task-types/TaskSquareFetch";
import { TaskSquareLink } from "./task-types/TaskSquareLink";
import { TaskUnstructured } from "./task-types/TaskUnstructured";
import { TaskUserAssignment } from "./task-types/TaskUserAssignment";
import { TaskBaseExecutionData } from "./TaskExecution";
import { TaskType } from "./TaskType";

export type Confirmation = {
  title: string;
  body: string;
  cancelLabelText?: string;
  continueLabelText?: string;
};

export enum TaskSpecificNotification {
  DEFAULT = "DEFAULT",
  AUTO_ID = "AUTO_ID",
}

export type Submission = {
  title?: string;
  message: string;
};

export type TaskBaseData = {
  confirmation?: Confirmation;
  submission?: Submission;
  share?: boolean;
  requestTracking?: boolean;
  notifyProcessOwner?: boolean;
};

export type TaskBase<
  T extends TaskType,
  D extends TaskBaseData,
  E extends TaskBaseExecutionData,
> = {
  id?: string;
  process_id: string;
  root_process_id?: string;
  execution_role_id?: string;
  type?: T;
  name: string;
  description?: string;
  created_at?: Date;
  updated_at?: Date;
  created_by_user_id?: string;
  previous_task_id?: string;
  next_task_id?: string;
  execution_data?: E;
  used_variables?: string[];
  task_identifier_name: string;
  data?: D;
  role?: Role;
  is_context?: boolean;
  completion_title?: string;
  task_specific_notification?: TaskSpecificNotification;
};

export type Task =
  | TaskCheck
  | TaskForm
  | TaskEmail
  | TaskAssignment
  | TaskShortCircuit
  | TaskCalendlyEvent
  | TaskCalendlyScheduledEvent
  | TaskOAuthLink
  | TaskSquareFetch
  | TaskSquareLink
  | TaskDocuSignEvent
  | TaskInvitation
  | TaskAcceptInvitation
  | TaskUserAssignment
  | TaskCompleteProcessDependency
  | TaskProcessStart
  | TaskProcessMonitor
  | TaskCreateAccount
  | TaskRunwayApiCall
  | TaskBeginPhase
  | TaskUnstructured
  | TaskContent;
